import { transport } from 'config/transport';

export function callApiSaveChiCongDoan(congDoanId, month, year, body) {
    return transport.post(`/congdoan/${congDoanId}/thuchi/chicongdoan`, body, { params: { month, year } });
}
